// extracted by mini-css-extract-plugin
module.exports = {"date":"date-module--date--1g35_"};